"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Tableau Services APIs
 * Open API specification for Tableau Services APIs
 *
 * The version of the OpenAPI document: latest
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const runtime = require("../runtime");
const models_1 = require("../models");
/**
 *
 */
class ExtensionsSettingsApi extends runtime.BaseAPI {
    /**
     * Adds an extension to the list of extensions globally blocked on a server. This method can only be called by server administrators.
     * Add an Extension to the Block List of a Server
     */
    extensionsServerSettingsServiceCreateBlockListItemRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.com.tableau.extensions.serversettings.v2.BlockListItem+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/extensions/settings/server/blocklist`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ComTableauExtensionsServersettingsV2BlockListItemToJSON(requestParameters.comTableauExtensionsServersettingsV2BlockListItem),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ComTableauExtensionsServersettingsV2BlockListItemFromJSON(jsonValue));
        });
    }
    /**
     * Adds an extension to the list of extensions globally blocked on a server. This method can only be called by server administrators.
     * Add an Extension to the Block List of a Server
     */
    extensionsServerSettingsServiceCreateBlockListItem(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.extensionsServerSettingsServiceCreateBlockListItemRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Deletes a specific extension from the global list of blocked extensions on a server. This method can only be called by server administrators.
     * Delete an Extension from the Block List of a Server
     */
    extensionsServerSettingsServiceDeleteBlockListItemRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.luid === null || requestParameters.luid === undefined) {
                throw new runtime.RequiredError('luid', 'Required parameter requestParameters.luid was null or undefined when calling extensionsServerSettingsServiceDeleteBlockListItem.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/extensions/settings/server/blocklist/{luid}`.replace(`{${"luid"}}`, encodeURIComponent(String(requestParameters.luid))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Deletes a specific extension from the global list of blocked extensions on a server. This method can only be called by server administrators.
     * Delete an Extension from the Block List of a Server
     */
    extensionsServerSettingsServiceDeleteBlockListItem(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.extensionsServerSettingsServiceDeleteBlockListItemRaw(requestParameters);
        });
    }
    /**
     * Lists the extensions on the blocked list of a server. This method can only be called by server administrators.
     * List Blocked Extensions on a Server
     */
    extensionsServerSettingsServiceGetBlockListRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/extensions/settings/server/blocklist`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ComTableauExtensionsServersettingsV2BlockListFromJSON(jsonValue));
        });
    }
    /**
     * Lists the extensions on the blocked list of a server. This method can only be called by server administrators.
     * List Blocked Extensions on a Server
     */
    extensionsServerSettingsServiceGetBlockList(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.extensionsServerSettingsServiceGetBlockListRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Gets the details of a specific extension on the blocked list of a server. This method can only be called by server administrators.
     * Get a Blocked Extension on a Server
     */
    extensionsServerSettingsServiceGetBlockListItemRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.luid === null || requestParameters.luid === undefined) {
                throw new runtime.RequiredError('luid', 'Required parameter requestParameters.luid was null or undefined when calling extensionsServerSettingsServiceGetBlockListItem.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/extensions/settings/server/blocklist/{luid}`.replace(`{${"luid"}}`, encodeURIComponent(String(requestParameters.luid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ComTableauExtensionsServersettingsV2BlockListItemFromJSON(jsonValue));
        });
    }
    /**
     * Gets the details of a specific extension on the blocked list of a server. This method can only be called by server administrators.
     * Get a Blocked Extension on a Server
     */
    extensionsServerSettingsServiceGetBlockListItem(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.extensionsServerSettingsServiceGetBlockListItemRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Lists the extension settings of a Tableau Server. This method can only be called by server administrators.
     * List Server Extension Settings
     */
    extensionsServerSettingsServiceGetServerSettingsRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/extensions/settings/server`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ComTableauExtensionsServersettingsV2ServerSettingsFromJSON(jsonValue));
        });
    }
    /**
     * Lists the extension settings of a Tableau Server. This method can only be called by server administrators.
     * List Server Extension Settings
     */
    extensionsServerSettingsServiceGetServerSettings(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.extensionsServerSettingsServiceGetServerSettingsRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Updates the global settings for extensions on a server. This method can only be called by server administrators.
     * Update Server Extension Settings
     */
    extensionsServerSettingsServiceUpdateServerSettingsRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.com.tableau.extensions.serversettings.v2.ServerSettings+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/extensions/settings/server`,
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ComTableauExtensionsServersettingsV2ServerSettingsToJSON(requestParameters.comTableauExtensionsServersettingsV2ServerSettings),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ComTableauExtensionsServersettingsV2ServerSettingsFromJSON(jsonValue));
        });
    }
    /**
     * Updates the global settings for extensions on a server. This method can only be called by server administrators.
     * Update Server Extension Settings
     */
    extensionsServerSettingsServiceUpdateServerSettings(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.extensionsServerSettingsServiceUpdateServerSettingsRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Adds an extension to the list of safe extensions in the site your are signed into. This method can be called by both site and server administrators.
     * Add an Extension to the Safe List of a Site
     */
    extensionsSiteSettingsServiceCreateSafeListItemRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.com.tableau.extensions.sitesettings.v2.SafeListItem+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/extensions/settings/site/safelist`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ComTableauExtensionsSitesettingsV2SafeListItemToJSON(requestParameters.comTableauExtensionsSitesettingsV2SafeListItem),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ComTableauExtensionsSitesettingsV2SafeListItemFromJSON(jsonValue));
        });
    }
    /**
     * Adds an extension to the list of safe extensions in the site your are signed into. This method can be called by both site and server administrators.
     * Add an Extension to the Safe List of a Site
     */
    extensionsSiteSettingsServiceCreateSafeListItem(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.extensionsSiteSettingsServiceCreateSafeListItemRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Deletes a specific extension from the safe list of the site you are signed into. This method can be called by both site and server administrators.
     * Delete an Extension from the Safe List of a Site
     */
    extensionsSiteSettingsServiceDeleteSafeListItemRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.luid === null || requestParameters.luid === undefined) {
                throw new runtime.RequiredError('luid', 'Required parameter requestParameters.luid was null or undefined when calling extensionsSiteSettingsServiceDeleteSafeListItem.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/extensions/settings/site/safelist/{luid}`.replace(`{${"luid"}}`, encodeURIComponent(String(requestParameters.luid))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Deletes a specific extension from the safe list of the site you are signed into. This method can be called by both site and server administrators.
     * Delete an Extension from the Safe List of a Site
     */
    extensionsSiteSettingsServiceDeleteSafeListItem(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.extensionsSiteSettingsServiceDeleteSafeListItemRaw(requestParameters);
        });
    }
    /**
     * Lists the extensions on the safe list of the site you are signed into. This method can be called by both site and server administrators.
     * Lists the extension settings of a Tableau Server.
     */
    extensionsSiteSettingsServiceGetSafeListRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/extensions/settings/site/safelist`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ComTableauExtensionsSitesettingsV2SafeListFromJSON(jsonValue));
        });
    }
    /**
     * Lists the extensions on the safe list of the site you are signed into. This method can be called by both site and server administrators.
     * Lists the extension settings of a Tableau Server.
     */
    extensionsSiteSettingsServiceGetSafeList(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.extensionsSiteSettingsServiceGetSafeListRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Gets the details of a specific extension on the safe list of the site you are signed into. This method can be called by both site and server administrators.
     * Get an Allowed Extension in a Site
     */
    extensionsSiteSettingsServiceGetSafeListItemRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.luid === null || requestParameters.luid === undefined) {
                throw new runtime.RequiredError('luid', 'Required parameter requestParameters.luid was null or undefined when calling extensionsSiteSettingsServiceGetSafeListItem.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/extensions/settings/site/safelist/{luid}`.replace(`{${"luid"}}`, encodeURIComponent(String(requestParameters.luid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ComTableauExtensionsSitesettingsV2SafeListItemFromJSON(jsonValue));
        });
    }
    /**
     * Gets the details of a specific extension on the safe list of the site you are signed into. This method can be called by both site and server administrators.
     * Get an Allowed Extension in a Site
     */
    extensionsSiteSettingsServiceGetSafeListItem(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.extensionsSiteSettingsServiceGetSafeListItemRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Lists the extension settings of the site you are signed into. This method can be called by both site and server administrators.
     * List Site Extension Settings
     */
    extensionsSiteSettingsServiceGetSiteSettingsRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/extensions/settings/site`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ComTableauExtensionsSitesettingsV2SiteSettingsFromJSON(jsonValue));
        });
    }
    /**
     * Lists the extension settings of the site you are signed into. This method can be called by both site and server administrators.
     * List Site Extension Settings
     */
    extensionsSiteSettingsServiceGetSiteSettings(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.extensionsSiteSettingsServiceGetSiteSettingsRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Updates a specific extension from the safe list of the site you are signed into. This method can be called by both site and server administrators.
     * Updates an Extension from the Safe List of a Site
     */
    extensionsSiteSettingsServiceUpdateSafeListItemRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.luid === null || requestParameters.luid === undefined) {
                throw new runtime.RequiredError('luid', 'Required parameter requestParameters.luid was null or undefined when calling extensionsSiteSettingsServiceUpdateSafeListItem.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.com.tableau.extensions.sitesettings.v2.SafeListItem+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/extensions/settings/site/safelist/{luid}`.replace(`{${"luid"}}`, encodeURIComponent(String(requestParameters.luid))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ComTableauExtensionsSitesettingsV2SafeListItemToJSON(requestParameters.comTableauExtensionsSitesettingsV2SafeListItem),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ComTableauExtensionsSitesettingsV2SafeListItemFromJSON(jsonValue));
        });
    }
    /**
     * Updates a specific extension from the safe list of the site you are signed into. This method can be called by both site and server administrators.
     * Updates an Extension from the Safe List of a Site
     */
    extensionsSiteSettingsServiceUpdateSafeListItem(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.extensionsSiteSettingsServiceUpdateSafeListItemRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Updates the settings for extensions for the site you are signed into. This method can be called by both site and server administrators.
     * Update Site Extension Settings
     */
    extensionsSiteSettingsServiceUpdateSiteSettingsRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.com.tableau.extensions.sitesettings.v2.SiteSettings+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/extensions/settings/site`,
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ComTableauExtensionsSitesettingsV2SiteSettingsToJSON(requestParameters.comTableauExtensionsSitesettingsV2SiteSettings),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ComTableauExtensionsSitesettingsV2SiteSettingsFromJSON(jsonValue));
        });
    }
    /**
     * Updates the settings for extensions for the site you are signed into. This method can be called by both site and server administrators.
     * Update Site Extension Settings
     */
    extensionsSiteSettingsServiceUpdateSiteSettings(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.extensionsSiteSettingsServiceUpdateSiteSettingsRaw(requestParameters);
            return yield response.value();
        });
    }
}
exports.ExtensionsSettingsApi = ExtensionsSettingsApi;
